import { render, staticRenderFns } from "./OpeningHourForm.vue?vue&type=template&id=d47793a0"
import script from "./OpeningHourForm.vue?vue&type=script&lang=ts"
export * from "./OpeningHourForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports